import React from 'react';
import './styles.scss';
import PropTypes from 'prop-types';
import { Card } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export default function BatchSchedule(props) {
  const contentToPopulate = props.isFetching ? [1, 1, 1, 1] : props.data;
  const timeSheet = () => {
    const timeSheetData = [];
    contentToPopulate.map((row, index) => {
      timeSheetData.push(
        <li
          key={index}
          className={props.isFetching ? 'mb-20' : 'timeline-item'}
        >
          <h4>{props.isFetching ? <Skeleton width="50%" /> : row.title}</h4>
          <div className="time">
            {props.isFetching ? <Skeleton /> : row.time}
          </div>
        </li>
      );
    });
    return timeSheetData;
  };

  const timeSheetHeader = () => {
    const timeSheetHead = (
      <React.Fragment>
        <div>{props.month}</div>
        <div>{props.date}</div>
        <div className="day">({props.day})</div>
      </React.Fragment>
    );
    return timeSheetHead;
  };

  return (
    <Card className="card batch-schedule-card">
      <ul>
        {(props.isFetching || contentToPopulate.length != 0) && timeSheet()}
      </ul>
      {props.isFetching ? (
        <Skeleton className="date-overlay skeleton" />
      ) : (
        <div className="date-overlay">
          {contentToPopulate.length != 0 && timeSheetHeader()}
        </div>
      )}
    </Card>
  );
}

BatchSchedule.propTypes = {
  data: PropTypes.array,
  month: PropTypes.string,
  date: PropTypes.string,
  day: PropTypes.string,
  key: PropTypes.number,
  isFetching: PropTypes.bool,
};
